import {createContext} from "react";

export const modalContext = createContext<BuildModalContext>({
    activeModal: '',
    setActiveModal: (value: string | null) => {},
    modalData: {},
    setModalData: (data: Object) => {},
});
